import { useStore } from "../store";

export const useIsMobile = () => useStore((state) => state.isMobile);
export const useDeviceType = () => useStore((state) => state.deviceType);
